module.exports = __webpack_public_path__ + "media/assets/icons/chevron-right3-3feb4568b80187ff983b4ec46023f0e4.svg";